// ---------------------------------------------------------------------------
// Runtime configuration. FrontendStack publishes /config.json (API URL +
// Cognito IDs) next to the SPA at deploy time. When present, the app runs in
// "live" mode against the real API; otherwise it falls back to the in-browser
// mock (e.g. local `npm run dev`).
// ---------------------------------------------------------------------------

export interface RuntimeConfig {
  apiUrl?: string;
  /** SSE streaming endpoint (IAM-auth Lambda Function URL); empty = pseudo-stream. */
  streamUrl?: string;
  /** Identity pool for SigV4-signing streaming requests in the browser. */
  identityPoolId?: string;
  userPoolId?: string;
  userPoolClientId?: string;
  region?: string;
}

let cfg: RuntimeConfig = {};

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const data = (await res.json()) as RuntimeConfig;
      // Ignore an unsubstituted template (e.g. contains "${Token").
      if (data.apiUrl && !data.apiUrl.includes('${')) cfg = data;
    }
  } catch {
    /* no config -> mock mode */
  }
  return cfg;
}

export function getConfig(): RuntimeConfig {
  return cfg;
}

export function isLive(): boolean {
  return Boolean(cfg.apiUrl && cfg.userPoolId && cfg.userPoolClientId);
}
